import { useEffect } from "react";
import { useNavigate } from "react-router";
import { setUserInfo } from "../Reducers/userReducer";
import { useDispatch } from "react-redux";
import { getCookie } from "../utils/cookies";
import { decryptToken } from "../utils/auth";

const Authenticate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const params = new URLSearchParams(window.location.search);
    const clientSessionId = params.get("CostaClick_SessionId");
    const referer = params.get("referer");
    const encryptedToken = getCookie("cck_user");

    useEffect(() => {
        document.body.classList.add("body-denied");

        return () => {
            document.body.classList.remove("body-denied");
        };
    }, []);

    useEffect(() => {
        if (clientSessionId) {
            const form = document.createElement("form");
            form.name = "autoForm";
            form.method = "POST";
            form.action = referer;

            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "CostaClick_SessionId";
            input.value = clientSessionId;

            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
        }
    }, [clientSessionId, referer]);

    useEffect(() => {
        if (encryptedToken) {
            const payload = decryptToken(encryptedToken);
            if (!payload) {
                return;
            } else {
                dispatch(setUserInfo(payload));
                localStorage.setItem("user", JSON.stringify(payload));
                navigate("/");
            }
        } else {
            console.error("Token not found");
            return;
        }
    }, [encryptedToken]);

    return <div></div>;
};

export default Authenticate;
